/* ==========================================================================
   VITAL VIAL - Welcome popup
   Opens on every new visit to the site. Closing it hides it only until the
   visitor leaves (browser session); subscribing hides it for the remembered
   number of days. Traps focus while open and restores it on close.
   ========================================================================== */
(function () {
  'use strict';

  var root = document.querySelector('[data-vv-popup]');
  if (!root) return;

  var panel = root.querySelector('.vv-popup__panel');
  var key = root.getAttribute('data-key') || 'vv-popup';
  var days = parseInt(root.getAttribute('data-days'), 10) || 30;
  var delay = parseFloat(root.getAttribute('data-delay')) || 0;
  var scrollPct = parseInt(root.getAttribute('data-scroll'), 10) || 0;

  var opened = false;
  var lastFocus = null;
  var releaseTrap = null;

  // Storage can throw in private mode; the popup must still work.
  // Subscribed: remembered across visits for `days`.
  function readSubscribed() {
    try { return parseInt(window.localStorage.getItem(key + '-subscribed'), 10) || 0; } catch (e) { return 0; }
  }
  function writeSubscribed() {
    try { window.localStorage.setItem(key + '-subscribed', String(Date.now())); } catch (e) { /* ignore */ }
  }
  // Dismissed: remembered for this visit only, so it shows again next visit.
  function readDismissed() {
    try { return window.sessionStorage.getItem(key + '-dismissed') === '1'; } catch (e) { return false; }
  }
  function writeDismissed() {
    try { window.sessionStorage.setItem(key + '-dismissed', '1'); } catch (e) { /* ignore */ }
  }

  function suppressed() {
    if (readDismissed()) return true;
    var stamp = readSubscribed();
    if (!stamp) return false;
    return (Date.now() - stamp) < days * 86400000;
  }

  function open() {
    if (opened) return;
    opened = true;
    lastFocus = document.activeElement;
    root.hidden = false;
    // Next frame so the transition runs.
    requestAnimationFrame(function () { root.classList.add('is-open'); });
    document.documentElement.classList.add('vv-popup-open');
    if (window.vvTrapFocus && panel) releaseTrap = window.vvTrapFocus(panel, close);
    // Focus the dialog itself so no focus ring appears on the close button.
    if (panel) panel.focus({ preventScroll: true });
  }

  function close() {
    if (!opened) return;
    opened = false;
    writeDismissed();
    root.classList.remove('is-open');
    document.documentElement.classList.remove('vv-popup-open');
    if (releaseTrap) { releaseTrap(); releaseTrap = null; }
    var done = function () { root.hidden = true; };
    root.addEventListener('transitionend', function h(e) {
      if (e.target !== root) return;
      root.removeEventListener('transitionend', h);
      done();
    });
    setTimeout(done, 500);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  root.addEventListener('click', function (e) {
    if (e.target.closest('[data-vv-popup-close]')) { e.preventDefault(); close(); }
  });

  // Any CTA across the site can open the popup on demand.
  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('[data-vv-popup-open], a[href="#launch"]');
    if (!trigger) return;
    e.preventDefault();
    if (root.querySelector('.vv-popup__success')) return;
    opened = false;
    open();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && opened) close();
  });

  // A successful signup re-renders with the success message (and the code);
  // show it and remember, so a subscriber is not asked again.
  if (root.querySelector('.vv-popup__success')) {
    writeSubscribed();
    open();
    return;
  }

  if (suppressed()) return;
  // Never interrupt the theme editor.
  if (window.Shopify && window.Shopify.designMode) return;

  if (delay > 0) setTimeout(open, delay * 1000);
  else if (scrollPct === 0) setTimeout(open, 1200);

  if (scrollPct > 0) {
    var onScroll = function () {
      var doc = document.documentElement;
      var max = doc.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      var pct = (window.scrollY / max) * 100;
      if (pct >= scrollPct) {
        window.removeEventListener('scroll', onScroll);
        open();
      }
    };
    window.addEventListener('scroll', onScroll, { passive: true });
  }
})();
